export default __webpack_public_path__ + "static/media/Erlik's Ring of the Underworld.a5a082d1.jpg";